/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formpurpose_Label1Inputs */

const ja_contact_formpurpose_label1 = /** @type {(inputs: Contact_Formpurpose_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポンサーシップの目的・理由`)
};

const en_contact_formpurpose_label1 = /** @type {(inputs: Contact_Formpurpose_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Purpose`)
};

/**
* | output |
* | --- |
* | "Your Purpose" |
*
* @param {Contact_Formpurpose_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formpurpose_label1 = /** @type {((inputs?: Contact_Formpurpose_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formpurpose_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formpurpose_label1(inputs)
	return en_contact_formpurpose_label1(inputs)
});
export { contact_formpurpose_label1 as "contact_formPurpose_label" }